import React from "react";

const AppFooter = ({ className = "" }) => (
  <footer
    className={`font-bold text-center sm:text-right text-xs sm:text-sm text-gray-500 ${className}`.trim()}
  >
    © All Rights Reserved - MSI/Srijan
  </footer>
);

export default AppFooter;
